module.exports = __webpack_public_path__ + "fonts/FreightNeoProLight-Regular.53262dc6.otf";